import { makeCancelablePromise } from '@datocms/rest-client-utils';
export function uploadFileOrBlobToS3(fileOrBlob, url, _a) {
  var _b = _a === void 0 ? {} : _a,
      onProgress = _b.onProgress;

  var xhr = new XMLHttpRequest();
  return makeCancelablePromise(new Promise(function (resolve, reject) {
    if (onProgress && xhr.upload) {
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) {
          onProgress({
            type: 'UPLOADING_FILE',
            payload: {
              progress: Math.round(e.loaded / e.total * 100)
            }
          });
        }
      };
    }

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve();
        } else {
          reject(new Error("Status ".concat(xhr.status)));
        }
      }
    };

    xhr.addEventListener('error', reject, false);
    xhr.open('PUT', url, true);
    xhr.send(fileOrBlob);
  }), function () {
    xhr.onreadystatechange = null;
    xhr.abort();
  });
}